export default "__VITE_ASSET__BINdSQJl__"